var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDown == true)?_c('div',{staticClass:"mongolia",on:{"click":function($event){return _vm.mongolia()}}},[_c('img',{attrs:{"src":require("@/assets/image/dakai.png"),"alt":""}}),_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("Click on the upper right corner“...”"),_c('br'),_vm._v("Choose to open in the browser"),_c('br'),_vm._v("Download App")])
}]

export { render, staticRenderFns }